// Sentry browser SDK init.
//
// One of the three files where importing the Sentry SDK is allowed — the Nuxt
// module boundary (docs/PORTABILITY.md, the @sentry fence exception in
// eslint.config.mjs). The module dynamically imports this file inside a Nuxt
// plugin, so `useRuntimeConfig()` is available here.
//
// A browser DSN is PUBLIC by design, so it rides in `runtimeConfig.public`.
// With no DSN configured we log one line and no-op — the honest-degrade
// precedent from the email outbox sender (no throw: error tracking is optional).
import * as Sentry from "@sentry/nuxt";

import {
  beforeBreadcrumb,
  beforeSend,
  type ScrubbableBreadcrumb,
  type ScrubbableEvent,
} from "./app/utils/sentryScrub";

const config = useRuntimeConfig();
const dsn = config.public.sentryDsn;

if (!dsn) {
  console.info(
    JSON.stringify({
      severity: "INFO",
      event: "error_tracking_disabled",
      plane: "portal-client",
      reason: "no DSN",
    }),
  );
} else {
  Sentry.init({
    dsn,
    environment: config.public.appEnv,
    release: config.public.sentryRelease || undefined,
    sendDefaultPii: false,
    // The scrubbers mutate in place; scrub, then return the same (now scrubbed)
    // reference in its native Sentry type.
    beforeSend: (event) => {
      beforeSend(event as unknown as ScrubbableEvent);
      return event;
    },
    beforeBreadcrumb: (breadcrumb) => {
      beforeBreadcrumb(breadcrumb as unknown as ScrubbableBreadcrumb);
      return breadcrumb;
    },
  });
}
